import { connect } from 'react-redux';
import _ from 'lodash';
import { getScreenData, removeScreenData, setScreenData, Store } from 'cw-ui-core';
import AddExternalIdP from 'src/features/authentication-v2/components/AddExternalIdP/AddExternalIdP';
import { toArray, toMap } from 'src/util/Util';
import { addExternalIdPProvider, assignUsersToExternalIdP } from 'src/services/LoginProviderService';
import { generateErrorsArray } from 'src/features/authentication-v2/components/utils';
import {
    EXTERNAL_IDP_REQUIRED_FORM_FIELDS,
    CONFIGURE_EXTERNAL_IDP_STEP_INDEX,
    ASSIGN_USERS_STEP_INDEX,
    ADD_EXTERNAL_IDP,
} from 'src/features/authentication-v2/constants';
import { setErrorByIndex } from 'src/asio-neon-components/Stepper/utils';

const mapStateToProps = state => {
    const screenKey = ADD_EXTERNAL_IDP;

    const errors = toArray(getScreenData(state.screen, ['errors'], screenKey));
    const identityProviderData = toMap(getScreenData(state.screen, ['identityProvider'], screenKey));
    const users = toArray(getScreenData(Store().getState().screen, ['selectedUsers'], screenKey));

    const usersSelected = !_.isEmpty(users);
    const isFilled = _.every(EXTERNAL_IDP_REQUIRED_FORM_FIELDS, field => !_.isEmpty(identityProviderData[field]));

    return {
        errors,
        isFilled,
        usersSelected,
        screenKey,
    };
};

const mapDispatchToProps = dispatch => {
    const screenKey = ADD_EXTERNAL_IDP;

    return {
        onDidMount: () => {
            dispatch(setScreenData('errors', generateErrorsArray(2), screenKey));
            dispatch(
                setScreenData(
                    'identityProvider',
                    {
                        clientName: '',
                        clientId: '',
                        description: '',
                        authority: '',
                        responseType: '',
                    },
                    screenKey
                )
            );
        },
        onAddExternalIdP: onSuccess => {
            const identityProvider = getScreenData(Store().getState().screen, ['identityProvider'], screenKey).toJS();

            identityProvider.scopes = ['openid', 'email', 'profile'];

            // will set an error for Configure External IdP step, if the API request fails
            const onError = () => setErrorByIndex(CONFIGURE_EXTERNAL_IDP_STEP_INDEX, true, 'errors', screenKey);

            Store().runSaga(addExternalIdPProvider, identityProvider, onSuccess, onError, screenKey);
        },
        onAssignUsers: onSuccess => {
            const scheme = getScreenData(Store().getState().screen, ['identityProvider', 'scheme'], screenKey);
            const users = getScreenData(Store().getState().screen, ['selectedUsers'], screenKey);

            // will set an error for Assign Users step, if the API request fails
            const onError = () => setErrorByIndex(ASSIGN_USERS_STEP_INDEX, true, 'errors', screenKey);

            Store().runSaga(assignUsersToExternalIdP, scheme, users, onSuccess, onError, screenKey);
        },
        onComponentWillUnmount: () => {
            dispatch(removeScreenData(['identityProvider'], screenKey));
            dispatch(removeScreenData(['selectedUsers'], screenKey));
            dispatch(removeScreenData(['errors'], screenKey));
            dispatch(removeScreenData(['fieldsValidity'], screenKey));
            dispatch(removeScreenData(['formErrors'], screenKey));
            dispatch(removeScreenData(['isValidAuthorityUrl'], screenKey));
        },
    };
};

const AddExternalIdPContainer = connect(mapStateToProps, mapDispatchToProps)(AddExternalIdP);

export default AddExternalIdPContainer;
